import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { ClassesView, classesFiltersSchema } from '@/modules/classes'
import { StudentsAndClassesView } from '@/modules/studentsAndClasses'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/students-and-classes/classes/')({
  validateSearch: search => classesFiltersSchema.parse(search),
  component: () => (
    <StudentsAndClassesView>
      <ClassesView />
    </StudentsAndClassesView>
  ),
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.students-and-classes', { ns: 'classes' }),
      i18n.t('title.classes', { ns: 'classes' })
    ])
})
